/**
 * Modular Verra Closet Configurator
 * Version: 1.0.1
 * Build: 5
 * Last Commit: 83de5cf
 * Build Date: 2025-09-01
 * 
 * This file was automatically generated.
 * Do not edit the version header manually.
 */











import {
  CSS3DRenderer,
  CSS3DObject,
} from "three/examples/jsm/renderers/CSS3DRenderer.js";
import * as THREE from "three";
import { WardrobeSize } from "./constant";
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
//comment
export function create3DCSSElement(
  x,
  y,
  z,
  rotation,
  ifSmall,
  cabinets,
  selectionBars,
  scene
) {
  var containerDiv = document.createElement("div");
  containerDiv.id = "containerstyle";

  var css3DDiv = document.createElement("div");
  css3DDiv.id = "addButton";
  // css3DDiv.className = 'selectionbar selection' + (cabinets.length - 1);
  css3DDiv.className = `selectionbar selection${cabinets.length - 1} ${
    ifSmall ? "tower-small" : "tower-large"
  }`;

  const cancelsvg = ` <div class="remove-tower remove-tower-svg" onclick="removeTower(${
    cabinets.length - 1
  })">
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8" height="8" viewBox="0 0 14 14">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_3567" data-name="Rectangle 3567" width="14" height="14" transform="translate(1013 165)" fill="#fff" stroke="#707070" stroke-width="1" opacity="0"/>
    </clipPath>
  </defs>
  <g id="Mask_Group_593" data-name="Mask Group 593" transform="translate(-1013 -165)" clip-path="url(#clip-path)">
    <circle id="Ellipse_395" data-name="Ellipse 395" cx="7" cy="7" r="7" transform="translate(1027 179) rotate(180)" fill="#f27662"/>
    <g id="Group_2200" data-name="Group 2200" transform="translate(1018.142 170.142)">
      <line id="Line_342" data-name="Line 342" x2="3.717" y2="3.717" transform="translate(0)" fill="none" stroke="#fff" stroke-width="1"/>
      <line id="Line_343" data-name="Line 343" x1="3.717" y2="3.717" transform="translate(0)" fill="none" stroke="#fff" stroke-width="1"/>
    </g>
  </g>
</svg>
		</div>`;

  // Create elements for left and right icons
  var leftIcon = document.createElement("div");
  leftIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
			<g id="Group_4218" data-name="Group 4218" transform="translate(1140 164) rotate(180)">
				<g id="Ellipse_394" data-name="Ellipse 394" transform="translate(1140 164) rotate(180)" fill="none" stroke="#000" stroke-width="1">
				<circle cx="7" cy="7" r="7" stroke="none"/>
				<circle cx="7" cy="7" r="6.5" fill="none"/>
				</g>
				<g id="Group_2195" data-name="Group 2195" transform="translate(1134.806 159.817) rotate(180)">
				<path id="Path_1763" data-name="Path 1763" d="M0,3.076,2.986,0,5.928,3.029" transform="translate(0 5.928) rotate(-90)" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="1"/>
				</g>
			</g>
			</svg>
			`;
  leftIcon.classList.add("icon");

  // Check if it's the first tower
  if (cabinets.length === 1) {
    leftIcon.classList.add("disabled");
  }

  var rightIcon = document.createElement("div");
  rightIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
			<g id="Group_4217" data-name="Group 4217" transform="translate(-1126 -150)">
				<g id="Ellipse_394" data-name="Ellipse 394" transform="translate(1140 164) rotate(180)" fill="none" stroke="#000" stroke-width="1">
				<circle cx="7" cy="7" r="7" stroke="none"/>
				<circle cx="7" cy="7" r="6.5" fill="none"/>
				</g>
				<g id="Group_2195" data-name="Group 2195" transform="translate(1134.806 159.817) rotate(180)">
				<path id="Path_1763" data-name="Path 1763" d="M0,3.076,2.986,0,5.928,3.029" transform="translate(0 5.928) rotate(-90)" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="1"/>
				</g>
			</g>
			</svg>
`; // You can use any icon library or custom SVG here
  rightIcon.classList.add("icon");

  var cancelSvgElement = document
    .createRange()
    .createContextualFragment(cancelsvg);

  // Create a div to hold the text and cancel SVG
  var textAndCancelContainer = document.createElement("div");
  textAndCancelContainer.classList.add("text-cancel-button");

  // Create text element for tower number
  var textDiv = document.createElement("div");
  textDiv.innerHTML = "Tower " + cabinets.length;
  textDiv.classList.add("tower-text");

  var cancelSvgElement = document
    .createRange()
    .createContextualFragment(cancelsvg);

  // Append text and cancel SVG to the container
  textAndCancelContainer.appendChild(textDiv);
  textAndCancelContainer.appendChild(cancelSvgElement);

  // Append elements in the desired order
  css3DDiv.appendChild(leftIcon);
  css3DDiv.appendChild(textAndCancelContainer);
  css3DDiv.appendChild(rightIcon);

  containerDiv.appendChild(css3DDiv);

  var css3DObject = new CSS3DObject(containerDiv);
  css3DObject.position.set(x, y, z);
  css3DObject.rotation.y = rotation;
  css3DObject.name = "css3DObject";
  css3DObject.scale.set(0.0125, 0.0075, 0.0125);
  // css3DObject.scale.set(0.0125, 0.00125, 0.0125);

  scene.add(css3DObject);
  selectionBars.push(css3DObject);
}
